import Vue from 'vue'
import Router, { Route } from 'vue-router'
import * as R from 'ramda'
import Axios from 'axios'

Vue.use(Router)

const isAuthenticated = ():boolean => {
  const token = sessionStorage.getItem('token')
  if (token) return true
  else return false
}

const guard = (to:Route, from: Route, next:any) => {
  if (R.equals(to.path, '/')) next()
  else if (R.equals(to.path, '/login') && isAuthenticated()) next('/dashboard')
  else if (!R.equals(to.path, '/login') && !isAuthenticated()) next('/login')
  else next()
}

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      component: () => import('./views/home/HomePage.component.vue')
    },
    {
      path: '/login',
      component: () => import('@/views/login/LoginPage.component.vue')
    },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/DashboardPage.component.vue'),
      children: [
        {
          path: '',
          component: () => import('@/views/dashboard/graphic/GraphicPage.component.vue')
        },
        {
          path: 'documents',
          component: () => import('@/views/dashboard/document/DocumentPage.component.vue')
        },
        {
          path: 'customers',
          component: () => import('@/views/dashboard/customer/CustomerPage.component.vue')
        },
        {
          path: 'products',
          component: () => import('@/views/dashboard/product/ProductPage.component.vue')
        },
        {
          path: 'customers-access',
          component: () => import('@/views/dashboard/customers-access/CustomersAccessPage.component.vue')
        }

      ]
    }
  ]
})

router.beforeEach(guard)

Axios.interceptors.response.use((response) => response, (error) => {
  if (R.equals(error.response.status, 401)) {
    sessionStorage.removeItem('token')
    if (!R.equals(router.currentRoute.path, '/login')) {
      router.push('/login')
      return
    }
  }
  return Promise.reject(error)
})

export default router
